// Globals
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuProps } from 'antd';

// Components
import { StyledPageWrapper } from '../../components/Styled';
import { StyledMainTitleWrapper, StyledMenu, StyledPageTitle } from './ProductsMainContainerStyles';

// Modules
import { usePermissions, Resource } from '@/modules/Permissions';

// Helpers
import { ProductsTabs, getProductsTabsConfig } from '../../helpers/configs';
import { useQueryParams } from '@/hooks';
import { IdsManagerProvider } from '@/context';

const PRODUCTS_TAB_RESOURCE: Record<string, Resource> = {
  [ProductsTabs.PRODUCTS]: Resource.PRODUCT,
  [ProductsTabs.PRODUCTS_OF_MONTH]: Resource.PRODUCT_OF_MONTH,
  [ProductsTabs.TOP_PRODUCTS]: Resource.TOP_PRODUCT,
};

const ProductsMainContainer = () => {
  const { t } = useTranslation(['products']);
  const { canView } = usePermissions();
  const defaultTab = useQueryParams('tab');
  const tabsConfig = useMemo(
    () => getProductsTabsConfig(t).filter((tab) => canView(PRODUCTS_TAB_RESOURCE[tab.key])),
    [canView],
  );
  const [selectedKey, setSelectedKey] = useState(defaultTab ?? '');
  const selectedTab = tabsConfig.find((item) => item.key === selectedKey) ?? tabsConfig[0];

  const onClick: MenuProps['onClick'] = (e) => {
    setSelectedKey(e.key as ProductsTabs);
  };

  return (
    <IdsManagerProvider>
      <StyledPageWrapper>
        <StyledMainTitleWrapper>
          <StyledPageTitle>{t('products_main_title')}</StyledPageTitle>
          <StyledMenu
            mode="horizontal"
            items={tabsConfig}
            defaultSelectedKeys={selectedTab ? [selectedTab.key] : []}
            onClick={onClick}
          />
        </StyledMainTitleWrapper>

        {selectedTab?.content}
      </StyledPageWrapper>
    </IdsManagerProvider>
  );
};

export default ProductsMainContainer;
